<template>
  <section class="overflow-hidden rounded-lg border border-slate-200 bg-white">
    <header class="border-b border-slate-200 px-4 py-3">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div class="min-w-0">
          <h3 class="text-base font-semibold text-slate-900">容量账本</h3>
          <p class="mt-1 text-sm text-slate-500">
            {{ plan?.planMonth || '-' }} · {{ filteredItems.length }} / {{ items.length }} 个客户
          </p>
        </div>
        <label class="block w-full sm:w-48">
          <span class="sr-only">搜索客户</span>
          <input
            v-model.trim="keyword"
            type="search"
            class="form-input w-full rounded-md border-slate-300 text-sm"
            placeholder="搜索公司"
          />
        </label>
      </div>
    </header>

    <div v-if="filteredItems.length === 0" class="data-table-empty is-compact">
      {{ items.length === 0 ? '暂无容量账本' : '没有匹配的客户' }}
    </div>

    <div v-else class="overflow-x-auto">
      <table class="min-w-[720px] w-full divide-y divide-slate-200 text-left text-sm">
        <thead class="bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-500">
          <tr>
            <th class="px-4 py-3">公司</th>
            <th class="px-4 py-3 text-right">目标额度</th>
            <th class="px-4 py-3 text-right">已用额度</th>
            <th class="px-4 py-3 text-right">剩余额度</th>
            <th class="px-4 py-3 text-right">拆分笔数</th>
            <th class="px-4 py-3">状态</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 bg-white">
          <tr v-for="(item, index) in filteredItems" :key="item.id || item.customerId || index" class="hover:bg-slate-50">
            <td class="max-w-[220px] px-4 py-3">
              <div class="truncate font-medium text-slate-900">{{ ledgerCompanyName(item) }}</div>
            </td>
            <td class="px-4 py-3 text-right font-medium text-slate-700">{{ formatInvoiceAmount(ledgerTargetAmount(item)) }}</td>
            <td class="px-4 py-3 text-right font-medium text-slate-700">{{ formatInvoiceAmount(ledgerUsedAmount(item)) }}</td>
            <td class="px-4 py-3 text-right font-medium text-slate-700">{{ formatInvoiceAmount(ledgerRemainingAmount(item)) }}</td>
            <td class="px-4 py-3 text-right text-slate-700">{{ ledgerSplitCount(item) }}</td>
            <td class="px-4 py-3">
              <span :class="['status-badge', ledgerStatus(item).className]">{{ ledgerStatus(item).label }}</span>
              <p v-if="item.errorMessage || item.warningMessage" :class="['mt-1 text-xs font-medium', item.errorMessage ? 'text-red-600' : 'text-amber-600']">
                {{ item.errorMessage || item.warningMessage }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { formatInvoiceAmount } from '../utils'
import {
  ledgerCompanyName,
  ledgerRemainingAmount,
  ledgerSplitCount,
  ledgerStatus,
  ledgerTargetAmount,
  ledgerUsedAmount
} from '../rules.mjs'

const props = defineProps({
  items: { type: Array, default: () => [] },
  plan: { type: Object, default: null },
  loading: { type: Boolean, default: false }
})

const keyword = ref('')

const filteredItems = computed(() => {
  const text = keyword.value.trim().toLowerCase()
  if (!text) return props.items
  return props.items.filter(item => ledgerCompanyName(item).toLowerCase().includes(text))
})
</script>
